import { useTranslation } from 'react-i18next';

export default function useUserLanguage() {
  const { i18n } = useTranslation();
  const lang = i18n.languages[0];
  const loadableLocale = lang === 'xx' ? 'en' : lang;
  return loadableLocale;
}
